import api from './index';
// 分页查询轮播图列表
export const getBannerList = (current = 1, size = 10) => {
    return api.get('/admin/banners', {
        params: { current, size }
    });
};
// 获取启用的轮播图列表（小程序端使用）
export const getEnabledBanners = () => {
    return api.get('/app/banners');
};
// 根据ID查询轮播图详情
export const getBannerById = (id) => {
    return api.get(`/admin/banners/${id}`);
};
// 创建轮播图
export const createBanner = (data) => {
    return api.post('/admin/banners', data);
};
// 更新轮播图
export const updateBanner = (id, data) => {
    return api.put(`/admin/banners/${id}`, data);
};
// 删除轮播图
export const deleteBanner = (id) => {
    return api.delete(`/admin/banners/${id}`);
};
// 更新轮播图状态
export const updateBannerStatus = (id, status) => {
    return api.patch(`/admin/banners/${id}/status`, null, {
        params: { status }
    });
};
// 获取公司简介
export const getCompanyProfile = () => {
    return api.get('/company-profile');
};
// 更新公司简介
export const updateCompanyProfile = (data) => {
    return api.put('/admin/company-profile', data);
};
// 上传图片
export const uploadImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 60000
    });
};
// 删除图片
export const deleteImage = (url) => {
    return api.delete('/upload/image', {
        params: { url }
    });
};
// ========== 基本信息设置 ==========
export const getBasicSettings = () => {
    return api.get('/admin/settings/basic');
};
export const updateBasicSettings = (data) => {
    return api.put('/admin/settings/basic', data);
};
// ========== 物流设置 ==========
export const getLogisticsSettings = () => {
    return api.get('/admin/logistics/settings');
};
export const updateLogisticsSettings = (data) => {
    return api.put('/admin/logistics/settings', data);
};
// ========== 仪表盘 ==========
export const getDashboardStats = () => {
    return api.get('/admin/dashboard/stats');
};
export const getOrderTrend = (days = 7) => {
    return api.get('/admin/dashboard/orders/trend', { params: { days } });
};
export const getCategorySales = (days = 30, top = 5) => {
    return api.get('/admin/dashboard/category-sales', { params: { days, top } });
};
